module.exports = __webpack_public_path__ + "img/ztkc.260209ff.jpg";